import { Hero } from "../components/home/Hero";
import { Marquee } from "../components/site/Marquee";
import { ServicesBento } from "../components/home/ServicesBento";
import { Approach } from "../components/home/Approach";
import { AboutTeaser } from "../components/home/AboutTeaser";
import { LatestBlogs } from "../components/home/LatestBlogs";
import { TrustSection } from "../components/home/TrustSection";
import { CTA } from "../components/site/CTA";

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <ServicesBento />
      <Approach />
      <AboutTeaser />
      <TrustSection />
      <LatestBlogs />
      <CTA />
    </>
  );
}
